export * from './useCacheInfiniteIndexQuery.types';
export { default as useCacheInfiniteIndexQuery } from './useCacheInfiniteIndexQuery';
